import Vue from 'vue';
Vue.config.productionTip = false;

import ExpressOrdersApp from './App.vue';

// Vuex setup /////////////////////////////////////////////////////////

import { store } from './vuex/store';
///////////////////////////////////////////////////////////////////////

// indexDB setup //////////////////////////////////////////////////////

import './indexDb/idbMain';
///////////////////////////////////////////////////////////////////////

// Router Setup ///////////////////////////////////////////////////////

import router from './router/router';
////////////////////////////////////////////////////////////////////////

// globally registered components //////////////////////////////////////
//

import fontawesome from '@fortawesome/fontawesome';
import { faBars, faUserCircle, faEnvelope, faCog, faTimes, faDownload, faListOl, faUtensils, faEye, faPencilAlt, faHeartbeat, faArrowLeft, faHome, faMapMarkerAlt, faCreditCard, faEllipsisV, faHistory, faEnvelopeOpen, faCalendarAlt, faSignOutAlt, faExclamationTriangle, faLock, faLockOpen, faCheckCircle, faArrowRight, faCaretLeft, faCaretRight, faSyncAlt } from '@fortawesome/fontawesome-free-solid';

fontawesome.library.add( faBars, faUserCircle, faEnvelope, faCog, faTimes, faDownload, faListOl, faUtensils, faEye, faPencilAlt, faHeartbeat, faArrowLeft, faHome, faMapMarkerAlt, faCreditCard, faEllipsisV, faHistory, faEnvelopeOpen, faCalendarAlt, faSignOutAlt, faExclamationTriangle, faLock, faLockOpen, faCheckCircle, faArrowRight, faCaretLeft, faCaretRight, faSyncAlt );
//

import VueQrcodeReader from 'vue-qrcode-reader';
Vue.use( VueQrcodeReader );
//

import 'vue-tel-input/dist/vue-tel-input.css';
import VueTelInput from 'vue-tel-input';
Vue.use( VueTelInput );
/////////////////////////////////////////////////////////////////////////

// Service Worker setup /////////////////////////////////////////////////

import './registerServiceWorker';
import './sw';
/////////////////////////////////////////////////////////////////////////

new Vue({

  render: h => h( ExpressOrdersApp ),
  router,
  store
}).$mount( '#expressOrdersApp' )
